import { signInWithCustomToken } from 'firebase/auth'
import { auth, getAppCheckToken } from './firebase'

const STORAGE_KEY = 'spelaren_vipps_login'

export function saveVippsSession({ state, codeVerifier, redirectUri }) {
  sessionStorage.setItem(
    STORAGE_KEY,
    JSON.stringify({ state, codeVerifier, redirectUri, createdAt: Date.now() })
  )
}

export function loadVippsSession() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY)
    if (!raw) return null
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function clearVippsSession() {
  sessionStorage.removeItem(STORAGE_KEY)
}

/**
 * @param {string} apiBase - f.eks. '' for same-origin, eller 'https://spelaren.no'
 */
export async function fetchVippsStatus(apiBase = '') {
  const res = await fetch(`${apiBase}/api/auth/vipps/status`)
  if (!res.ok) return { enabled: false }
  return res.json()
}

export async function startVippsLogin(apiBase = '', platform = 'web') {
  const res = await fetch(`${apiBase}/api/auth/vipps/start`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ platform }),
  })
  if (!res.ok) {
    const text = await res.text()
    throw new Error(text || 'Kunne ikke starte Vipps-innlogging')
  }
  const data = await res.json()
  saveVippsSession({
    state: data.state,
    codeVerifier: data.codeVerifier,
    redirectUri: data.redirectUri,
  })
  window.location.href = data.authorizationUrl
}

export async function exchangeVippsCode({ apiBase = '', code, state }) {
  const session = loadVippsSession()
  if (!session?.codeVerifier || !session?.redirectUri) {
    throw new Error('Vipps-sesjon mangler. Start innlogging på nytt.')
  }
  if (state && session.state && state !== session.state) {
    throw new Error('Ugyldig state fra Vipps')
  }

  const res = await fetch(`${apiBase}/api/auth/vipps/exchange`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      code,
      codeVerifier: session.codeVerifier,
      redirectUri: session.redirectUri,
      state: state || session.state,
    }),
  })
  if (!res.ok) {
    const text = await res.text()
    throw new Error(text || 'Vipps-innlogging feilet')
  }
  const data = await res.json()
  if (!auth) throw new Error('Firebase er ikke konfigurert')

  const result = await signInWithCustomToken(auth, data.firebaseCustomToken)
  const idToken = await result.user.getIdToken()
  clearVippsSession()

  localStorage.setItem('firebaseToken', idToken)
  localStorage.setItem(
    'firebaseUser',
    JSON.stringify({
      uid: result.user.uid,
      phoneNumber: data.phoneNumber || result.user.phoneNumber,
      displayName: data.displayName,
      email: data.email,
    })
  )

  // Opprett/hent bruker i backend (upsert skjer allerede i exchange, men /me er trygg)
  try {
    const appCheckToken = await getAppCheckToken()
    const headers = {
      Authorization: `Bearer ${idToken}`,
      'Content-Type': 'application/json',
    }
    if (appCheckToken) headers['X-Firebase-AppCheck'] = appCheckToken
    await fetch(`${apiBase}/api/auth/me`, { headers })
  } catch (_) {
    // fortsett
  }

  return idToken
}
